import type { HandlerFn } from "..";
import { apiPost, type IRequestError } from "../../../../api";
import { invalidateTableCache } from "../../queryCache";
import { toast } from "../../../toast";

export const postRequestHandler: HandlerFn = async (ctx) => {
  const url = ctx.config?.url;
  if (!url || typeof url !== "string") {
    toast.error("Не указан адрес действия");
    return;
  }

  try {
    await apiPost(url);

    invalidateTableCache(`${window.location.pathname}table_data/`);
    toast.success(
      typeof ctx.config?.title === "string"
        ? `Действие «${ctx.config.title}» выполнено`
        : "Действие выполнено",
    );
  } catch (error) {
    toast.error(
      (error as IRequestError)?.message || "Не удалось выполнить действие",
    );
  }
};
